import { render, staticRenderFns } from "./SortWithBlackChevronArea.vue?vue&type=template&id=16c7415e&scoped=true&"
import script from "./SortWithBlackChevronArea.vue?vue&type=script&lang=js&"
export * from "./SortWithBlackChevronArea.vue?vue&type=script&lang=js&"
import style0 from "./SortWithBlackChevronArea.vue?vue&type=style&index=0&id=16c7415e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7415e",
  null
  
)

export default component.exports